import React from 'react';
import PropTypes from 'prop-types';
import Popup from '../Popup';

/**
 * Component displayed while checking the signature status
 */
export const SignStatusCheck = ({
    statusMessage = 'Checking Signature status',
}) => (
    <button
        className="bg-yellow-400 font-medium py-2 px-2 rounded cursor-default"
        type="button"
        disabled
    >
        <div>
            <img
                src="images/icp-ajax-loader.gif"
                className="inline w-5 h-5 mb-px mr-2"
                alt="Loading"
            />
            {statusMessage}
        </div>
    </button>
);

SignStatusCheck.propTypes = {
    statusMessage: PropTypes.string,
};

/**
 * Base component for the "Sign with Adobe Sign" button
 */
export const SignWithAdobeSignButton = ({
    overlay,
    handleBeforeAdobeSign,
    popupHeader = 'Digitally sign with Adobe Sign',
    buttonText = 'Sign with Adobe Sign',
}) => (
    <Popup
        header={popupHeader}
        overlay={overlay}
        onPopupOpen={handleBeforeAdobeSign}
    >
        <button
            className="bg-yellow-400 hover:bg-yellow-500 text-base font-medium py-2 px-3 rounded"
            type="button"
            data-testid="adobe-sign"
        >
            {buttonText}
        </button>
    </Popup>
);

SignWithAdobeSignButton.propTypes = {
    overlay: PropTypes.element.isRequired,
    handleBeforeAdobeSign: PropTypes.func,
    popupHeader: PropTypes.string,
    buttonText: PropTypes.string,
};

/**
 * Component displayed when the document has been successfully signed
 */
export const DocumentSignedButton = ({ message = 'Successfully Signed' }) => (
    <div className="bg-green-50 py-2 px-3 rounded flex items-center justify-center">
        <img
            src="images/ok-checkbox.svg"
            className="inline w-5 h-5 mr-1.5"
            alt="Success"
        />
        <span className="text-green-600 text-base font-medium">{message}</span>
    </div>
);

DocumentSignedButton.propTypes = {
    message: PropTypes.string,
};
